import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { connect, Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Backdrop, CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HashLoader } from 'react-spinners';
import PropTypes from 'prop-types';
import 'react-toastify/dist/ReactToastify.css';
import store from './src/redux/store';
import App from './App';
import FeedbackToast from './src/components/FeedbackToast';
import { shades } from './theme';
import './index.css';
import ThemeProviderComponent from './src/contexts/ThemeContext';

const mapDispatchToProps = {};

const mapStateToProps = (state) => ({
  showLoading: Boolean(state.showLoading)
});

const root = createRoot(document.getElementById('root'));

const RootApplication = ({ showLoading }) => {
  const [showLoadingState, setShowLoadingState] = useState(false);

  useEffect(() => {
    setShowLoadingState(showLoading);
  }, [showLoading]);

  return (
    <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <ThemeProviderComponent>
          <CssBaseline />
          <App />
          <ToastContainer newestOnTop />
          <FeedbackToast />

          <Backdrop
            sx={{
						  color: '#fff',
						  zIndex: (theme) => theme.zIndex.modal + 1,
						  backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }}
            open={showLoadingState}
          >
            <HashLoader color={shades.primary[500]} size={100} />
          </Backdrop>
        </ThemeProviderComponent>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

RootApplication.propTypes = {
  showLoading: PropTypes.bool.isRequired
};

const ConnectedRootApplication = connect(
  mapStateToProps,
  mapDispatchToProps
)(RootApplication);

root.render(
  <Provider store={store}>
    <ConnectedRootApplication />
  </Provider>
);
